import { Box, Typography } from "@mui/material";

// Normalize role to a single string for comparison (sender_role can be stored as string or array)
const normalizeRole = (r: string | string[] | undefined): string => {
  if (r == null) return "";
  return Array.isArray(r) ? (r[0] ?? "").toLowerCase() : String(r).toLowerCase();
};

const FormatConversationHistory = (
  conversationData: string,
  user: { Role: string[] }
) => {
  const data = JSON?.parse(conversationData);
  const currentUserRole = normalizeRole(user?.Role) || "customer";
  return (
    data?.map((conversation: { message: any }, index: any) => {
      // Directly use the conversation object if it is a message
      const message = conversation.message || conversation;

      if (!message?.id) {
        console.error("Invalid message data", message);
        return null; // Skip rendering this item
      }

      const senderRole = normalizeRole(message.sender_role);
      const isCurrentUser = senderRole === currentUserRole;

      return (
        <Box key={message.id} mb={2} className="chat-box">
          <Box
            display="flex"
            flexDirection={isCurrentUser ? "row-reverse" : "row"}
          >
            <Box
              sx={{
                maxWidth: "70%",
                padding: "10px",
                borderRadius: "8px",
                backgroundColor:
                  isCurrentUser ? "#e3f2fd" : "#fff",
                border: "1px solid #ddd",
              }}
            >
              <Typography variant="subtitle2" color="textSecondary">
                <span style={{ color: "black" }}>
                  {message.sender_name || "Unknown"}
                </span>
              </Typography>
              <Typography variant="body1">
                {message.text || "No message"}
              </Typography>
              <Typography
                variant="subtitle2"
                color="textSecondary"
                sx={{ display: "flex", justifyContent: "right" }}
              >
                <span>{message.date || "Unknown date"}</span>
              </Typography>
            </Box>
          </Box>
        </Box>
      );
    }) || <Typography>No conversations available</Typography>
  );
};

export default FormatConversationHistory;
